import { Flex, PaperSection } from '@shared/components';

import { ExamEventScoreReportProvider } from '../../providers';
import { ExamEventScoreReportExportButton } from '../exam-event-score-report-export-button';
import { ExamEventScoreReportFilterSection } from '../exam-event-score-report-filter-section';
import { ExamEventScoreReportScoreLegendSection } from '../exam-event-score-report-score-legend-section';
import { ExamEventScoreReportSummarySection } from '../exam-event-score-report-summary-section';
import { ExamEventScoreReportTable } from '../exam-event-score-report-table';

export default function ExamEventScoreReportSection() {
  return (
    <ExamEventScoreReportProvider>
      <PaperSection
        title='รายงานสรุปผลการสอบ'
        endAdornment={<ExamEventScoreReportExportButton />}
        sx={(theme) => ({
          borderRadius: theme.shape.rounded(2),
        })}
      >
        <Flex
          sx={(theme) => ({
            p: theme.spacing(6),
            gap: theme.spacing(6),
            flexDirection: 'column',
          })}
        >
          <ExamEventScoreReportFilterSection />
          <ExamEventScoreReportSummarySection />
          <ExamEventScoreReportScoreLegendSection />
          <ExamEventScoreReportTable />
        </Flex>
      </PaperSection>
    </ExamEventScoreReportProvider>
  );
}
